/**
 * @name TYPE
 */
module.exports = {
    FRAG: -1,
    TEXT: 0,
    NODE: 1,
    VIEW: 2
}
